import { Tooltip } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InfoIcon from "@mui/icons-material/Info";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";

export default function RadioList(props) {
  const {
    label,
    name,

    // (event) => console.log(event.target.value)
    onChange = () => { },
    options = [],

    // Those throws the radio buttons in a row instead of stacking vertically.
    row = false,
    toolTip,
    value,
  } = props;
  return (
    <FormControl component="fieldset">
      {label ? (
        <Typography variant="h6">
          {label}
          {toolTip ? (
            <Tooltip title={toolTip}>
              <InfoIcon fontSize="medium" />
            </Tooltip>
          ) : null}
        </Typography>
      ) : null}
      <RadioGroup
        aria-label={name}
        name={name}
        onChange={(event) => {
          onChange(event);
        }}
        row={row}
        value={value}
      >
        {options.map((element) => {
          const { disabled = false, label, labelPlacement, value } = element;
          return (
            <FormControlLabel
              control={<Radio />}
              disabled={disabled}
              key={value}
              label={label}
              labelPlacement={labelPlacement}
              value={value}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
}
